import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';

export const Wrapper = styled.div`
  cursor: pointer;
  border: 2px dashed ${COLOR.GREY_3};
  width: 100%;
  height: 50px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  margin: 6px 6px 6px 0;
  padding: 0 14px;

  &:hover {
    border-color: ${COLOR.BLUE_1};
  }

  div {
    display: flex;
    align-items: center;
    pointer-events: none;

    svg {
      color: ${({ status }) => (status ? COLOR.GREEN_1 : COLOR.GREY_2)};
    }
  }

  p {
    color: ${({ status }) => (status ? COLOR.GREEN_1 : COLOR.GREY_2)};
    text-decoration: underline;
    font-weight: 500;
    font-size: 12px;
    margin-left: 14px;
  }

  span {
    color: ${COLOR.BLUE_1};
    font-weight: 600;
  }

  span {
    margin: 5px;
    font-size: 12px;
  }

  /* Mobile */
  @media screen and (min-width: 360px) {
    span, p { font-size: 16px; }
  }

  /* Ipad-Notebook */
  @media screen and (min-width: 700px) {
    padding: 0 24px;
    span, p { font-size: 18px; }
  }
`;
